import EmbedCodeDialog from '@/components/embed/EmbedCodeDialog';

interface TasksEmbedCodeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  formName?: string;
  embedCode: string;
}

export default function TasksEmbedCodeDialog({
  open,
  onOpenChange,
  formName,
  embedCode,
}: TasksEmbedCodeDialogProps) {
  return (
    <EmbedCodeDialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Codice Embed - ${formName || 'Form'}`}
      description="Copia questo codice e incollalo nel tuo sito web per mostrare il form. I dati inviati genereranno automaticamente un task nella board collegata."
      embedCode={embedCode}
    />
  );
}
